import { useState, useEffect, Dispatch } from 'react';
import {
  ErrorObject,
  DEFAULT_ERROR_STATE,
} from 'src/containers/client-assessment/types';
import { FlexRow, OptionTile } from '../Common';
import { QuestionTypeOption } from '../types';

type Props = {
  label: string;
  options?: QuestionTypeOption[];
  selectedQuestionId: string;
  questionnaireValue: any;
  setQuestionnaireValue: Dispatch<any>;
  error: ErrorObject;
  setError: Dispatch<ErrorObject>;
};

const NONE_OPTIONS = ['i_dont_like_to_read', 'none', 'other'];

function Checkbox({
  label,
  options = [],
  selectedQuestionId,
  questionnaireValue,
  setQuestionnaireValue,
  error,
  setError,
}: Props) {
  const [value, setValue] = useState<any[]>([]);

  useEffect(() => {
    const currentValue = questionnaireValue[selectedQuestionId];
    setValue(currentValue ? currentValue : []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [label]);

  useEffect(() => {
    if (value.length === 0)
      setError({
        message: 'Atleast one of the options need to be checked',
        valid: true,
      });
    else setError(DEFAULT_ERROR_STATE);
    setQuestionnaireValue({
      ...questionnaireValue,
      [selectedQuestionId]: value,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleChangeItem = (itemInfo: string) => {
    if (NONE_OPTIONS.includes(itemInfo)) setValue(([] as any).concat(itemInfo));
    else if (!value.includes(itemInfo))
      setValue(value.filter(i => !NONE_OPTIONS.includes(i)).concat(itemInfo));
    else setValue(value.filter(item => itemInfo !== item));
  };
  return (
    <FlexRow justify="flex-start" height={true}>
      {options.map((option, index) => (
        <OptionTile
          onClick={() => handleChangeItem(option.value)}
          selected={value.includes(option.value)}
          key={index.toString()}
        >
          <span>{option.label}</span>
        </OptionTile>
      ))}
    </FlexRow>
  );
}

export default Checkbox;
